import script from "./ProcedureTableFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureTableFooter.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureTableFooter.vue?vue&type=style&index=0&id=6de00e09&lang=scss"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QBtn});
